import React, { FC } from 'react'
import * as yup from 'yup'
import { Button } from '@docpace/shared-react-components/Button'

import {
    useReactHookForm,
    UseReactHookFormProps,
} from '@docpace/shared-react-hooks/useReactHookForm'
import { FormSubmitControls, FormTextField } from '@docpace/shared-react-components'

export interface AdminUpdateItemIntNumberFormProps
    extends Omit<UseReactHookFormProps, 'schema'> {
    name: string
    title: string
    onCancel?: () => any
}

export const AdminUpdateItemIntNumberForm: FC<AdminUpdateItemIntNumberFormProps> = (
    props
) => {
    const { onCancel, name, title, ...reactHookProps } = props
    const schema = {
        [name]: yup.number().nullable(),
    }
    const { FormWrapper, formController, submitError, doSubmit } =
        useReactHookForm({
            ...reactHookProps,
            schema,
        })

    const { getValues, setValue, control } = formController

    const defaultValue = reactHookProps?.defaultValues?.[name]

    return (
        <FormWrapper formComponentProps={{ autoComplete: 'off' }}>
            <div className="flex justify-between w-full">
                <FormTextField
                    name={name}
                    defaultValue={defaultValue}
                    type="number"
                />
                <button
                    type="button"
                    className="btn btn-sm w-14 btn-ghost"
                    onClick={() => {
                        setValue(name, null)
                    }}
                >
                    Clear
                </button>
            </div>

            <FormSubmitControls onCancel={onCancel} submitError={submitError} />
        </FormWrapper>
    )
}
